(function () {
  var CARD_SELECTOR = 'product-card[handle]';
  var cache = new Map();
  var inFlight = new WeakSet();
  var observer;
  var mutationTimer;

  function isListingPage() {
    return document.body && (
      document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-search')
    );
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || 'it-IT';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100).replace(/\s/g, '');
    } catch (error) {
      return '€' + (cents / 100).toFixed(2);
    }
  }

  function getDiscount(product) {
    var variants = product && product.variants ? product.variants : [];
    var best = null;

    variants.forEach(function (variant) {
      var price = Number(variant.price);
      var compareAtPrice = Number(variant.compare_at_price);

      if (compareAtPrice > price) {
        var percent = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);

        if (!best || percent > best.percent) {
          best = {
            price: price,
            compareAtPrice: compareAtPrice,
            percent: percent
          };
        }
      }
    });

    return best;
  }

  function fetchProduct(handle) {
    if (cache.has(handle)) {
      return cache.get(handle);
    }

    var request = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product JSON unavailable');
        }

        return response.json();
      })
      .catch(function () {
        return null;
      });

    cache.set(handle, request);
    return request;
  }

  function ensureBadge(card, discount) {
    var figure = card.querySelector('.product-card__figure');
    if (!figure) {
      return;
    }

    var list = figure.querySelector(':scope > badge-list.badge-list') || figure.querySelector('badge-list.badge-list');

    if (!list) {
      list = document.createElement('badge-list');
      list.className = 'badge-list badge-list--vertical';
      figure.insertBefore(list, figure.firstElementChild);
    }

    var badge = list.querySelector('on-sale-badge');

    if (!badge) {
      badge = document.createElement('on-sale-badge');
      badge.className = 'badge badge--on-sale';
      list.insertBefore(badge, list.firstElementChild);
    }

    badge.textContent = discount.percent + '%';
    badge.hidden = false;
    badge.removeAttribute('hidden');
    list.hidden = false;
    list.removeAttribute('hidden');
  }

  function ensurePrice(card, discount) {
    var priceList = card.querySelector('price-list');
    if (!priceList) {
      return;
    }

    var salePrice = priceList.querySelector('sale-price');
    if (salePrice) {
      salePrice.classList.remove('text-subdued');
      salePrice.classList.add('text-on-sale');
    }

    var compareAtPrice = priceList.querySelector('compare-at-price');
    if (!compareAtPrice) {
      compareAtPrice = document.createElement('compare-at-price');
      compareAtPrice.className = 'h6 text-subdued line-through';
      compareAtPrice.innerHTML = '<span class="sr-only">Prezzo </span><span class="money"></span>';
      priceList.appendChild(compareAtPrice);
    }

    var money = compareAtPrice.querySelector('.money');
    if (money) {
      money.textContent = formatMoney(discount.compareAtPrice);
    } else {
      compareAtPrice.textContent = formatMoney(discount.compareAtPrice);
    }

    compareAtPrice.hidden = false;
    compareAtPrice.removeAttribute('hidden');
  }

  function applySaleState(card, discount) {
    ensureBadge(card, discount);
    ensurePrice(card, discount);
  }

  function processCard(card) {
    if (!card || inFlight.has(card)) {
      return;
    }

    if (card.querySelector('on-sale-badge') && card.querySelector('compare-at-price')) {
      return;
    }

    var handle = card.getAttribute('handle');
    if (!handle) {
      return;
    }

    inFlight.add(card);

    fetchProduct(handle).then(function (product) {
      var discount = getDiscount(product);

      if (discount) {
        applySaleState(card, discount);
      }
    }).finally(function () {
      inFlight.delete(card);
    });
  }

  function scanCards() {
    if (!isListingPage()) {
      return;
    }

    document.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      if (observer) {
        observer.observe(card);
      } else {
        processCard(card);
      }
    });
  }

  function scheduleScan() {
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(scanCards, 120);
  }

  function init() {
    if (!isListingPage()) {
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            processCard(entry.target);
          }
        });
      }, {
        rootMargin: '300px 0px'
      });
    }

    scanCards();
    window.setTimeout(scanCards, 700);
    window.setTimeout(scanCards, 1800);

    document.addEventListener('globoFilterRenderCompleted', scheduleScan);
    document.addEventListener('globoFilterRenderSearchCompleted', scheduleScan);
    window.addEventListener('globoFilterRenderCompleted', scheduleScan);
    window.addEventListener('globoFilterRenderSearchCompleted', scheduleScan);

    new MutationObserver(scheduleScan).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();